var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-app":"true"}},[_c('AppLoader',{attrs:{"isLoading":_vm.isAppLoading}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }